import Entity from './entity';
export default class MetaSearchAgency extends Entity<string> {
  refId: string;
  reffererId: string;
}
